// Default menu settings configurations
import { from } from 'rxjs';
import {navOfficerItems}  from '../../_menu/menu-officer';
import {navStudentItems} from '../../_menu/menu-student';
import {navParentItems} from '../../_menu/menu-parent';
import { navPublicItems } from './../../_menu/menu-public';
import { navPncItems } from './../../_menu/menu-pnc';
export interface MenuItem {
  title: string;
  icon: string;
  page: string;
  class: string;
  isExternalLink?: boolean;
  issupportExternalLink?: boolean;
  badge: { type: string, value: string };
  submenu: {
    items: Partial<MenuItem>[];
  };
  section: string;
}

export interface MenuConfig {
  horizontal_menu: {
    items: Partial<MenuItem>[]
  };
  vertical_menu: {
    items: Partial<MenuItem>[]
  };
  vertical_std: {
    items: Partial<MenuItem>[]
  };
  vertical_parent: {
    items: Partial<MenuItem>[]
  };
  vertical_pnc: {
    items: Partial<MenuItem>[]
  };
  horizontal_public: {
    items: Partial<MenuItem>[]
  };
}

export const MenuSettingsConfig: MenuConfig = {
  horizontal_menu: {
    items: navOfficerItems
  },
  vertical_menu: {
    items: navOfficerItems
  },
  vertical_std: {
    items: navStudentItems
  },
  vertical_parent:{
    items:navParentItems
  },
  vertical_pnc:{
    items:navPncItems
  },
  horizontal_public: {
    items: navPublicItems
  },


};





